import { FunctionComponent, memo } from 'react';
import { Case as CaseType } from '~types';
import { useTranslation } from 'react-i18next';
import { GetName, SteamItemImage } from '../item';
import Currency from '../Currency';
import { Price } from '~ui/index';
import CaseMoney from '../../scss/images/case-money-2.png';
import CaseFree from '../../scss/images/case-free.png';
import { useConfig } from '../hooks';

interface FreeCaseProps {
  getCase: CaseType;
}

const FreeCase: FunctionComponent<FreeCaseProps> = ({ getCase }) => {
  const getActiveGame = getCase?.getActiveGame;
  const { t } = useTranslation();
  const getConfig = useConfig();

  return (
    <div className="case-item-free">
      <div className="case-item-free-content">
        <div className="case-free-money">
          <img src={CaseMoney} alt="" />
          <div className="case-free-prize-content">
            <div className="num">
              {getCase?.seo?.inputMoney} <Currency />
            </div>
            <div className="text">{t('to the account')}</div>
          </div>
        </div>
        <div
          className="in-case-item active status-4"
          data-rar={getActiveGame?.getItem?.color}
        >
          <div className="in-case-cost">
            {getConfig.isEU ? (
              <>
                <Currency />
                <Price sum={getActiveGame?.price} />
              </>
            ) : (
              <>
                <Price sum={getActiveGame?.price} />
                <Currency />
              </>
            )}
          </div>
          <div className="in-case-item-wrap">
            <div className="img">
                <div className="in-case-item-bg" />
              <SteamItemImage
                url={getActiveGame?.getItem?.getImage}
                size="350x350"
              />
            </div>
            <div className="in-case-info">
              <div className="in-case-item-name">
                <GetName getItem={getActiveGame?.getItem} type={0} />
              </div>
              <div className="in-case-item-desc">
                <GetName getItem={getActiveGame?.getItem} type={1} />
              </div>
            </div>
          </div>
        </div>
        <div className="case-free-prize">
          <img src={CaseFree} alt="" />
          <div className="case-free-prize-content">
            <div className="num">30</div>
            <div className="text">{t('free_case_opening_on_case')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(FreeCase);
